<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
-->

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${heroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">Discover the Magic of Play with Snooplay Toys</div>
          <div class="hero-desc">
            Explore 1,600+ handpicked toys — from licensed diecast cars to wooden playsets and big outdoor playhouses. Made for the modern Indian child.
          </div>
          <router-link class="hero-btn" to="/goods?categoryID=320">Shop Toys Now</router-link>
        </div>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <h2>New Arrivals</h2>
          <p>Fresh toys just landed</p>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹999</p>
          </div>
          <div class="why-item">
            <div class="why-icon">✨</div>
            <h3>Premium Quality</h3>
            <p>100% handpicked toys</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Easy Returns</h3>
            <p>7-day hassle-free returns</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payment</h3>
            <p>Multiple payment options</p>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Curated Toy Collections</h2>
              <p>Handpicked by our play experts</p>
            </div>
            <div class="section-tabs">
              <span class="tab-item" :class="{active: discoverActive==='TOYCARS'}" @click="discoverActive='TOYCARS'">TOY CARS</span>
              <span class="tab-item" :class="{active: discoverActive==='DIECAST'}" @click="discoverActive='DIECAST'">DIECAST</span>
              <span class="tab-item" :class="{active: discoverActive==='ACTION'}" @click="discoverActive='ACTION'">ACTION GAMES</span>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
          <router-link class="section-cta" to="/goods?categoryID=320">See More</router-link>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Time Offer</span>
            <h2>BIG PLAYSET COLLECTION 2026</h2>
            <p>Up to 30% Off on Big Playhouses & Outdoor Playsets</p>
            <router-link class="promo-btn" to="/goods?categoryID=330">Shop Now</router-link>
          </div>
          <div class="promo-image">
            <img v-if="promoImage" :src="promoImage" :alt="promoName" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Toy Cars & Vehicles</div>
              <div class="split-desc">
                From pullback monsters to licensed diecast — tiny wheels, big adventures.
              </div>
              <router-link class="section-cta" to="/goods?categoryID=320">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img v-if="splitImage1" :src="splitImage1" :alt="splitName1" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Learning & STEM</div>
              <div class="split-desc">
                Puzzles, building sets and STEM toys that make little minds grow.
              </div>
              <router-link class="section-cta" to="/goods?categoryID=327">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img v-if="splitImage2" :src="splitImage2" :alt="splitName2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as carouselsAPI from '@/api/carousels/'
import * as productsAPI from '@/api/products/'
import * as rankingAPI from '@/api/ranking/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

// Snooplay category IDs (Indian toy shop).
// In the backend (bigshop2) we use 320-331 because Bighaat's agriculture
// data already occupies 301-309.
const SNOOPLAY_TOY_CARS = 320
const SNOOPLAY_DIECAST = 321
const SNOOPLAY_PRETEND = 322
const SNOOPLAY_BLOCKS = 323
const SNOOPLAY_TRENDING = 324
const SNOOPLAY_OUTDOOR = 325
const SNOOPLAY_RIDE = 326
const SNOOPLAY_LEARNING = 327
const SNOOPLAY_ACTION = 328
const SNOOPLAY_WOODEN = 329
const SNOOPLAY_BIG_PLAYSETS = 330
const SNOOPLAY_LICENSED = 331

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据
      // Snooplay product lists used to back the hero / promo / split banners
      snooplayHeroList: [],
      snooplayPromoList: [],
      snooplaySplit1List: [],
      snooplaySplit2List: [],
      snooplayTab1List: [],
      snooplayTab2List: [],
      snooplayTab3List: [],
      phonesList: [], // 手机商品列表
      televisionsList: [], // 小米电视商品列表
      applianceList: [], // 家电商品列表
      applianceHotList: [], //热门家电商品列表
      accessoryList: [], //配件商品列表
      accessoryHotList: [], //热门配件商品列表
      phoneShellsList: [], // 保护套商品列表
      chargersList: [], //充电器商品列表
      applianceActive: 1, // 家电当前选中的商品分类
      accessoryActive: 1, // 配件当前选中的商品分类
      discoverActive: 'TOYCARS', // Discover section active tab
      start: 0,
      limit: 7,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    heroImage() {
      if (this.carousels && this.carousels.length) {
        return this.carousels[0].img_path
      }
      // Fallback: pick a random Snooplay Big Playset image
      const list = this.snooplayHeroList
      if (list && list.length) {
        return list[0].img_path
      }
      return 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7000893/img_00.webp'
    },
    heroName() {
      const list = this.snooplayHeroList
      if (list && list.length) {
        return list[0].name
      }
      return ''
    },
    promoImage() {
      const list = this.snooplayPromoList
      if (list && list.length) {
        return list[0].img_path
      }
      return ''
    },
    promoName() {
      const list = this.snooplayPromoList
      if (list && list.length) {
        return list[0].name
      }
      return ''
    },
    splitImage1() {
      const list = this.snooplaySplit1List
      if (list && list.length) {
        return list[0].img_path
      }
      return ''
    },
    splitName1() {
      const list = this.snooplaySplit1List
      if (list && list.length) {
        return list[0].name
      }
      return ''
    },
    splitImage2() {
      const list = this.snooplaySplit2List
      if (list && list.length) {
        return list[0].img_path
      }
      return ''
    },
    splitName2() {
      const list = this.snooplaySplit2List
      if (list && list.length) {
        return list[0].name
      }
      return ''
    },
    discoverProducts() {
      if (this.discoverActive === 'TOYCARS') return this.snooplayTab1List
      if (this.discoverActive === 'DIECAST') return this.snooplayTab2List
      return this.snooplayTab3List // Default ACTION
    }
  },
  watch: {
    // 家电当前选中的商品分类，响应不同的商品数据
    applianceActive: function(val) {
      if (this.applianceHotList == '') {
        this.applianceHotList = this.televisionsList
      }
      if (val == 1) {
        this.applianceList = this.applianceHotList
        return
      }
      if (val == 2) {
        this.applianceList = this.televisionsList
        return
      }
    },
    accessoryActive: function(val) {
      if (this.accessoryHotList == '') {
        this.accessoryHotList = this.chargersList
      }
      if (val == 3) {
        this.accessoryList = this.accessoryHotList
        return
      }
      if (val == 2) {
        this.accessoryList = this.phoneShellsList
        return
      }
      if (val == 1) {
        this.accessoryList = this.chargersList
        return
      }
    }
  },
  activated() {
    // 获取首页数据
    this.load()
  },
  methods: {
    load() {
      // Try to load carousels first (legacy hero source)
      carouselsAPI
        .listCarousels()
        .then(res => {
          if (res.status == 200) {
            this.carousels = res.data
          }
        })
        .catch(() => {
          // carousels load failed - keep banner fallback
        })
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })

      // ============ Snooplay: pull random products for the homepage ============
      // For each slot we fetch a large batch (so the user sees randomness on each visit),
      // then shuffle and keep a few items.
      // Hero & promo: pick colourful big playsets / outdoor toys
      this.loadSnooplaySlot(SNOOPLAY_BIG_PLAYSETS, 'snooplayHeroList', 30)
      this.loadSnooplaySlot(SNOOPLAY_BIG_PLAYSETS, 'snooplayPromoList', 30)
      // Split banners: left = toy cars, right = learning / puzzles
      this.loadSnooplaySlot(SNOOPLAY_TOY_CARS, 'snooplaySplit1List', 30)
      this.loadSnooplaySlot(SNOOPLAY_LEARNING, 'snooplaySplit2List', 30)
      // New Arrivals: random 8 products from Toy Cars collection (varied, fun, eye-catching)
      this.loadHomeProducts()

      // Discover section tabs — random 7 items per Snooplay category
      this.loadSnooplaySlot(SNOOPLAY_TOY_CARS, 'snooplayTab1List', 30, 7)
      this.loadSnooplaySlot(SNOOPLAY_DIECAST, 'snooplayTab2List', 30, 7)
      this.loadSnooplaySlot(SNOOPLAY_ACTION, 'snooplayTab3List', 30, 7)
    },
    /**
     * Fetch a batch of products from a given category, shuffle them and keep `keep`.
     * @param {number} categoryId  Snooplay category id
     * @param {string} listName    target data field name
     * @param {number} limit       how many to fetch (max per page)
     * @param {number} keep        how many to keep after shuffle (0 = keep all)
     */
    loadSnooplaySlot(categoryId, listName, limit = 30, keep = 1) {
      productsAPI
        .listProducts(categoryId, 0, limit)
        .then(res => {
          if (res.status === 200) {
            const items = (res.data && res.data.items) || []
            const shuffled = this.shuffle(items)
            this[listName] = keep > 0 ? shuffled.slice(0, keep) : shuffled
          }
        })
        .catch(() => {
          // snooplay slot load failed - keep silent, fallback section already shows
        })
    },
    // Find categories for Discover section
    findDiscoverCategories(list) {
      // Legacy hook kept for backward compatibility; Snooplay tabs are now
      // populated by loadSnooplaySlot above.
    },
    selectCategory(id) {
      if (this.activeCategoryId === id) return
      this.activeCategoryId = id
      this.homeStart = 0
      this.fetchHomeProducts(id)
    },
    fetchHomeProducts(categoryId) {
      // For Snooplay homepage we always pull the "Toy Cars & Vehicles" collection
      // (cat_id = 300) and shuffle. categoryId is kept for backward compatibility
      // but ignored.
      this.loadSnooplaySlot(SNOOPLAY_TOY_CARS, 'homeProducts', 80, this.homeLimit)
    },
    loadHomeProducts() {
      // Same as fetchHomeProducts(0); triggered on first mount.
      this.loadSnooplaySlot(SNOOPLAY_TOY_CARS, 'homeProducts', 80, this.homeLimit)
    },
    // 获取家电模块子组件传过来的数据
    getChildMsg(val) {
      this.applianceActive = val
    },
    // 获取配件模块子组件传过来的数据
    getChildMsg2(val) {
      this.accessoryActive = val
    },
    // 获取各类商品数据方法封装
    getProduct(categoryID, val) {
      productsAPI
        .listProducts(categoryID, this.start, this.limit)
        .then(res => {
          if (res.status === 200) {
            this[val] = this.shuffle(res.data.items || [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle
    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FAF6EF')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FAF6EF')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';
</style>